
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class DeleteCarrierAreaCommand
    extends IRequestCommand<
    IDeleteCarrierAreaRequest,
    ErrorDetails,
    IDeleteCarrierAreaRequest
    > {
    override _commandType: CommandRequestType = CommandRequestType.DELETE;

    public override setParameters(parameters: IDeleteCarrierAreaRequest) {
        this._commandBody = parameters;
        this.urlSections.push('carriers');
        this.urlSections.push(`${parameters.carrierId}`);
        this.urlSections.push('carrierArea');
        this.urlSections.push(`${parameters.id}`);
        this.composeUrl();
    }
}

export interface IDeleteCarrierAreaRequest extends ICommandParameters {
    carrierId: number;
    id: number;
}
